import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { GlobalService } from 'app/services/global.service';
import { ModuleauthService } from 'app/services/moduleauth.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ModulesAuthGuardService implements CanActivate {
  moduleAccess = false
  permissions:any
  accessModule = false

  constructor(private _authService: ModuleauthService, private _router: Router,public global: GlobalService) { }

 
  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    let url: string = state.url;
    console.log(state.url)
    return this.checkUserModule(next, url);
  }

  canActivateChild(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean{
    let url: string = state.url;
    console.log(state.url)
    return this.checkUserModule(next, url);
  }

  checkUserModule(route: ActivatedRouteSnapshot, url: any): boolean {
    console.log(route)
    url = route
    if (this._authService.isAuthenticatedmodule()) {
      const userRole = this._authService.getModule();
      console.log(userRole)
      this.permissions = userRole['permissions']
      console.log(this.permissions)
      const view = this.permissions.find(permission => permission.name === 'view');
      const add = this.permissions.find(permission => permission.name === 'add');
      const edit = this.permissions.find(permission => permission.name === 'edit');
      const deletePermission = this.permissions.find(permission => permission.name === 'delete');
      console.log(view.permission, add.permission , edit.permission , deletePermission.permission)
      if((view.permission > 0 &&  add.permission  <= 0 &&  edit.permission  <= 0 &&  deletePermission.permission  <= 0)) {
       this.accessModule = false 
       const errMsg = "No Access";
       this.global.failureErrorModal(errMsg);
       this._router.navigate(['/dashboard']);
      } else {
        this.accessModule = true
      }
      return this.accessModule
    }
    const errMsg = "No Access";
    this.global.failureErrorModal(errMsg);
    this._router.navigate(['/dashboard']);
    return false;
  }
}
